import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateMemberRoleInCompany, forceRemoveMemberFromCompany, leaveFromCompany } from '../../../../store/actions/companyActions';

class ManageMemberModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            newAccessLevel: -1,
            newAccessTitle: "",
        }
    }


    /// README: CALLING CLOUD FUNCTION TO: 
    // CAPID 2: TRANSFER CREATOR CREDENTIALS TO EMPLOYEE
    updateRoleChange = () => {
        const { companyData, changerEmployeeMapJson, toBeChangedEmployeeMapJson } = this.props;
        const { newAccessLevel } = this.state;

        if (changerEmployeeMapJson !== null || toBeChangedEmployeeMapJson !== null) {
            this.props.updateMemberRoleInCompany(changerEmployeeMapJson, toBeChangedEmployeeMapJson, companyData, newAccessLevel)
        } else {
            alert("Member not selected!");
        }
    }

    // CAPID 3: REMOVE MEMBER FROM COMPANY
    removeMember = () => {
        const { companyData, changerEmployeeMapJson, toBeChangedEmployeeMapJson } = this.props;
        if (changerEmployeeMapJson !== null || toBeChangedEmployeeMapJson !== null) {
            this.props.forceRemoveMemberFromCompany(changerEmployeeMapJson, toBeChangedEmployeeMapJson, companyData);
        } else {
            alert("Member not selected!");
        }
    }

    // CAPID 4: REMOVE MYSELF FROM COMPANY
    removeMyself = () => {
        const { companyData, userData } = this.props;
        this.props.leaveFromCompany(userData, companyData);
    }

    handleRoleSelect = (crole) => {
        this.setState({
            newAccessLevel: crole.access,
            newAccessTitle: crole.title,
        })
    }

    componentDidMount() {
        const { toBeChangedEmployeeMapJson, alu } = this.props;
        if (toBeChangedEmployeeMapJson !== null) {
            const access = toBeChangedEmployeeMapJson.access;
            this.setState({
                newAccessLevel: access,
                newAccessTitle: alu.textLC[access]
            })
        } else {
            this.setState({
                newAccessLevel: 3,
                newAccessTitle: alu.textLC[3]
            })
        }
    }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle, alu, userData, toBeChangedEmployeeMapJson,company } = this.props;
        const{capiMessage,showCapiLoader} = company;
        const { newAccessTitle } = this.state;
        const { companyRoles } = alu;

        const ueid = userData.uid + userData.employeeid;
        const tbcueid = toBeChangedEmployeeMapJson.uid + toBeChangedEmployeeMapJson.employeeid;
        const isChangerSame = ueid === tbcueid;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <p style={modalTitleStyle}>Change member role:</p>
                    <p style={modalInfoTextStyle}>* By updating member to this role will allow member to view relevant pages within the app.</p>
                    <br />
                    <div className="form-group text-left">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <div className="btn btn-warning btn-sm" style={{ borderRadius: '10px' }} onClick={() => this.updateRoleChange()}>Change the role</div>
                                </div>
                            </div>
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <div className="dropdown show">
                                        <span className="btn btn-flat btn-sm dropdown-toggle border-bottom" role="button" id="roleDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {newAccessTitle} level
                                        </span>
                                        <div className="dropdown-menu border" aria-labelledby="roleDropdownMenuLink">
                                            {companyRoles.map((crole, i) => {
                                                return (
                                                    <span style={{ fontSize: "13px" }} onClick={() => { this.handleRoleSelect(crole) }} role="button" className="dropdown-item" key={i} data-toggle="tooltip" data-placement="top">
                                                        {crole.title}
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <p style={{ color: "black", fontWeight: "bold", fontSize: "13px",marginTop:'5px',textAlign:'center' }}>{!showCapiLoader?capiMessage ?? "":<React.Fragment/>}</p> */}
                    </div>
                    <hr />
                    <div>
                        <p style={modalTitleStyle}>Remove member from company:</p>
                        <p style={modalInfoTextStyle}>* Removing member from your company may or may not have affects on member's previous activities.</p>
                        <p style={modalInfoTextStyle}>* You may also be able to restore all the activities by using member's saved traces from your company's account.</p>
                        <br />
                        {isChangerSame ? (<div className="btn btn-danger btn-sm float-right" style={{ borderRadius: '10px' }} onClick={() => this.removeMyself()}>I willingly remove myself from company</div>) : (<div className="btn btn-danger btn-sm float-right" onClick={() => this.removeMember()}>I willingly remove member from company</div>)}
                    </div>
                </div>
                <p style={{ color: "black", fontWeight: "bold", fontSize: "13px",marginTop:'10px',textAlign:'center' }}>{capiMessage ?? ""}</p>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        floor: state.floor,
        company: state.company,
        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        companyData: state.firestore.data.Company,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyBriefingsData: state.firestore.data.CompanyBriefings,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        forceRemoveMemberFromCompany: (changerEmployeeMapJson, toBeChangedEmployeeMapJson, companyModelJson) => dispatch(forceRemoveMemberFromCompany(changerEmployeeMapJson, toBeChangedEmployeeMapJson, companyModelJson)),
        leaveFromCompany: (requestMakerJson, companyModelJson) => dispatch(leaveFromCompany(requestMakerJson, companyModelJson)),
        updateMemberRoleInCompany: (changerEmployeeMapJson, toBeChangedEmployeeMapJson, companyModelJson, newAccessLevel) => dispatch(updateMemberRoleInCompany(changerEmployeeMapJson, toBeChangedEmployeeMapJson, companyModelJson, newAccessLevel)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageMemberModal)
